import styled from "styled-components";

export const Container = styled.div`
  background-color: white;
  border-radius: 8px;
  padding: 1.5rem;
  border: 1px solid #e5e7eb;
  width: 100%;
  max-width: 100%;
  overflow: hidden;
  box-sizing: border-box;

  @media (max-width: 768px) {
    padding: 1rem;
  }
`;

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.75rem;
  }
`;

export const TitleContainer = styled.div``;

export const Title = styled.h3`
  font-size: 14px;
  font-weight: 500;
  color: #181d27;
  margin: 0;
  font-family: "Inter", -apple-system, BlinkMacSystemFont, sans-serif;
`;

export const Subtitle = styled.p`
  margin: 0;
  color: #535862;
  font-size: 14px;
`;

export const Dropdown = styled.select`
  padding: 0.5rem 0.75rem;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  font-size: 14px;
  font-weight: 500;
  color: #374151;
  background-color: white;
  cursor: pointer;
  outline: none;
  font-family: "Inter", -apple-system, BlinkMacSystemFont, sans-serif;
`;

export const StrategyTabsContainer = styled.div`
  display: flex;
  gap: 0.5rem;
  margin-bottom: 20px;

  @media (max-width: 768px) {
    gap: 0.25rem;
    margin-bottom: 16px;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
`;

export const StrategyTab = styled.div`
  display: flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.375rem 0.75rem;
  background-color: ${(props) => (props.$isActive ? "#f9fafb" : "transparent")};
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  color: #374151;
  cursor: pointer;

  @media (max-width: 768px) {
    padding: 0.25rem 0.5rem;
    font-size: 11px;
    flex-shrink: 0;
    white-space: nowrap;
  }
`;

export const StrategyIcon = styled.img`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  object-fit: cover;
`;

export const StrategyLogo = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: #e5e7eb;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: 600;
  color: #6b7280;
`;

export const Divider = styled.div`
  border-top: 1px solid #e9eaeb;
  padding-top: 20px;
  padding-bottom: 20px;
`;

export const ContentContainer = styled.div`
  display: flex;
  gap: 1.5rem;
  align-items: stretch;
  flex: 1;
  width: 100%;
  max-width: 100%;
  overflow: hidden;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 1rem;
  }
`;

// Industry View Styles
export const TreemapContainer = styled.div`
  flex: 1;
  min-height: 420px;
  position: relative;
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid #e5e7eb;
  background-color: #f9fafb;

  @media (max-width: 768px) {
    min-height: 300px;
    order: 2;
  }
`;

export const TreemapRectangle = styled.div`
  position: absolute;
  left: ${(props) => props.$left}%;
  top: ${(props) => props.$top}%;
  width: ${(props) => props.$width}%;
  height: ${(props) => props.$height}%;
  background-color: ${(props) => props.$color};
  padding: 0.75rem;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  color: ${(props) => props.$textColor};
  box-sizing: border-box;
  border: 0.5px solid rgba(255, 255, 255, 0.3);

  @media (max-width: 768px) {
    padding: 0.4rem;
    min-height: 35px;
  }

  /* For very small rectangles, reduce padding further */
  &[style*="width: 2%"],
  &[style*="width: 3%"],
  &[style*="width: 4%"] {
    padding: 0.2rem;

    @media (max-width: 768px) {
      padding: 0.1rem;
    }
  }
`;

export const RectangleName = styled.div`
  font-size: ${(props) => props.$fontSize};
  font-weight: 600;
  margin-bottom: 0.25rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 1.2;

  @media (max-width: 768px) {
    margin-bottom: 0.125rem;
    line-height: 1.1;
  }
`;

export const RectangleValue = styled.div`
  font-size: ${(props) => props.$fontSize};
  color: ${(props) => props.$textColor};
  opacity: ${(props) => props.$opacity};
  margin-bottom: 0.125rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  @media (max-width: 768px) {
    margin-bottom: 0.0625rem;
    line-height: 1.1;
  }
`;

export const RectanglePercentage = styled.div`
  font-size: ${(props) => props.$fontSize};
  color: ${(props) => props.$textColor};
  opacity: ${(props) => props.$opacity};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  @media (max-width: 768px) {
    line-height: 1.1;
  }

  /* Ensure percentage is always visible */
  font-weight: 600;
`;

export const TableContainer = styled.div`
  flex: 1;
  max-width: 320px;
  background-color: white;
  padding: 1rem;
  align-self: flex-start;

  @media (max-width: 768px) {
    flex: none;
    width: 100%;
    max-width: 100%;
    order: 1;
    padding: 0.75rem;
    border-radius: 6px;
    border: 1px solid #e5e7eb;
    margin: 0;
  }
`;

export const TableHeader = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0 0 1rem 0;
  border-bottom: 1px solid #e5e7eb;
  font-size: 14px;
  font-weight: 500;
  color: #374151;
  font-family: "Inter", -apple-system, BlinkMacSystemFont, sans-serif;

  @media (max-width: 768px) {
    font-size: 13px;
    padding: 0 0 0.75rem 0;
    width: 100%;
  }
`;

export const TableRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 0;
  border-bottom: ${(props) =>
    props.$hasBorder ? "1px solid #f3f4f6" : "none"};

  @media (max-width: 768px) {
    padding: 0.75rem 0;
    width: 100%;
  }
`;

export const TableRowLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;

  @media (max-width: 768px) {
    gap: 0.5rem;
  }
`;

export const ColorIndicator = styled.div`
  width: 8px;
  height: 16px;
  border-radius: 4px;
  background-color: ${(props) => props.$color};
  border: ${(props) => (props.$needsBorder ? "1px solid #cbd5e1" : "none")};
  flex-shrink: 0;
`;

export const IndustryName = styled.span`
  font-size: 14px;
  color: #374151;
  font-weight: 400;
  font-family: "Inter", -apple-system, BlinkMacSystemFont, sans-serif;

  @media (max-width: 768px) {
    font-size: 13px;
    flex: 1;
  }
`;

export const PercentageBadge = styled.div`
  padding: 0.25rem 0.75rem;
  background-color: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  color: #374151;
  min-width: 45px;
  text-align: center;
  font-family: "Inter", -apple-system, BlinkMacSystemFont, sans-serif;

  @media (max-width: 768px) {
    font-size: 11px;
    padding: 0.2rem 0.6rem;
    min-width: 40px;
  }
`;

// Assets View Styles
export const AssetsContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const AssetTableWrapper = styled.div`
  margin-top: 1rem;
`;

export const AssetLogoContainer = styled.div`
  position: relative;
  width: 32px;
  height: 32px;
`;

export const AssetLogoImage = styled.img`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
  border: 1px solid #e2e8f0;
  display: block;
`;

export const AssetLogoFallback = styled.div`
  display: none;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: #3b82f6;
  color: #ffffff;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 600;
  border: 1px solid #e2e8f0;
`;

export const AssetCell = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const AssetInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

export const AssetSymbol = styled.div`
  font-weight: 500;
  font-size: 14px;
  color: #0f172a;
`;

export const AssetCompany = styled.div`
  font-size: 12px;
  color: #64748b;
`;

export const AssetText = styled.span`
  font-weight: 400;
  color: #0f172a;
`;

export const AssetValueContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const AssetValue = styled.div`
  font-weight: 400;
  color: #0f172a;
  font-size: 14px;
`;

export const AssetShares = styled.div`
  font-size: 12px;
  color: #64748b;
`;

export const StrategyBadgesContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
`;

export const StrategyBadge = styled.span`
  border-radius: 4px;
  font-size: 12px;
  color: #475569;
`;

export const LoadingMessage = styled.div`
  text-align: center;
  padding: 40px 20px;
  color: #64748b;
  font-size: 14px;
`;

export const EmptyMessage = styled.div`
  text-align: center;
  padding: 40px 20px;
  color: #64748b;
  font-size: 14px;
`;
